/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} For_Whom_Studio_LongInputs */

const en_for_whom_studio_long = /** @type {(inputs: For_Whom_Studio_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Every trainer has their own hours and clients, group classes have a seat limit, and nobody can be booked twice.`)
};

const pl_for_whom_studio_long = /** @type {(inputs: For_Whom_Studio_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Każdy trener ma swoje godziny i podopiecznych, zajęcia grupowe mają limit miejsc, a nikogo nie da się zarezerwować dwa razy.`)
};

/**
* | output |
* | --- |
* | "Every trainer has their own hours and clients, group classes have a seat limit, and nobody can be booked twice." |
*
* @param {For_Whom_Studio_LongInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const for_whom_studio_long = /** @type {((inputs?: For_Whom_Studio_LongInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<For_Whom_Studio_LongInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_for_whom_studio_long(inputs)
	return en_for_whom_studio_long(inputs)
});